// .kiro/specs/1600-cognito-firestore-auth — tracks the ACTUAL Firebase Auth
// state (via onAuthStateChanged), not our own bookkeeping of "did we call
// signInWithCustomToken". useFirebaseAuthBridge.js signs in asynchronously
// (a GraphQL round-trip to mint the custom token, then the Firebase SDK
// call) — any Firestore listener started before that resolves hits
// firestore.rules as request.auth == null and gets denied.
//
// This matters because Firestore's onSnapshot does NOT self-heal from a
// permission-denied error: once a listener errors out, it's dead — nothing
// re-subscribes it later just because auth became available. Combined with
// listener call sites that don't pass an errorCallback (so the error is
// silently swallowed and a "loading" flag never gets reset), the result was
// a permanently-stuck loading spinner on first page load — the sign-in
// round-trip is slower than the effects mounting, so the race was lost
// almost every time. Gate every chat-related Firestore listener on this
// hook's return value, in addition to whatever userId check already exists,
// so listeners only ever attempt to subscribe once request.auth is real.
import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

import { app } from './firebase';

const useFirebaseAuthReady = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const auth = getAuth(app);
    return onAuthStateChanged(auth, user => {
      setReady(!!user);
    });
  }, []);

  return ready;
};

export default useFirebaseAuthReady;
